import { render, staticRenderFns } from "./TreeNotificaciones.vue?vue&type=template&id=83d94fb2&scoped=true"
import script from "./TreeNotificaciones.vue?vue&type=script&lang=js"
export * from "./TreeNotificaciones.vue?vue&type=script&lang=js"
import style0 from "./TreeNotificaciones.vue?vue&type=style&index=0&id=83d94fb2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83d94fb2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83d94fb2')) {
      api.createRecord('83d94fb2', component.options)
    } else {
      api.reload('83d94fb2', component.options)
    }
    module.hot.accept("./TreeNotificaciones.vue?vue&type=template&id=83d94fb2&scoped=true", function () {
      api.rerender('83d94fb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/notificaciones/TreeNotificaciones.vue"
export default component.exports